import { useEffect } from 'react';
import { STATE } from './constants';
import { getNextStepKeys } from './steps';

const KEY_BY_PATH = Object.fromEntries(
  Object.entries(STATE).map(([key, path]) => [path, key]),
);

/**
 * The next step path(s) to warm, derived entirely from the ordered source of
 * truth in steps.js. When the next step is conditional (A/B or flag gated),
 * getNextStepKeys returns it AND the step after it, so both are warmed without
 * re-encoding any branch logic here.
 *
 * @param {string} stateKey the current step's path (a STATE value)
 * @returns {string[]} next step paths to warm
 */
export const getNextStateKeys = stateKey => {
  const key = KEY_BY_PATH[stateKey];
  if (!key) return [];

  return getNextStepKeys(key)
    .map(nextKey => STATE[nextKey])
    .filter(Boolean);
};

/**
 * Warms the next onboarding step's CMS content in the server-side cache while
 * the user is on the current step, so the real navigation's getServerSideProps
 * fetch is a warm Redis hit instead of a cold Storyblok call.
 */
export const usePrefetchNextStep = ({ stateKey }) => {
  useEffect(() => {
    if (!stateKey) return;
    getNextStateKeys(stateKey).forEach(nextKey => {
      if (!nextKey) return;
      fetch(`/api/onboarding/warm/${nextKey}/`).catch(() => {});
    });
  }, [stateKey]);
};
